import React from 'react';
import PropTypes from 'prop-types';

/**
 * Tanpa error boundary, satu error saat render (mis. nilai object yang lolos ke
 * JSX) membuat React meng-unmount seluruh tree, dan user cuma melihat halaman
 * putih tanpa petunjuk apa pun. Boundary ini menahan error di area terkecil
 * yang membungkusnya supaya sisa aplikasi tetap hidup.
 */
class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { error: null };
		this.handleReset = this.handleReset.bind(this);
	}

	static getDerivedStateFromError(error) {
		return { error };
	}

	componentDidCatch(error, errorInfo) {
		// eslint-disable-next-line no-console
		console.error('[ErrorBoundary]', error, errorInfo?.componentStack);
	}

	handleReset() {
		this.setState({ error: null });
	}

	render() {
		const { error } = this.state;
		const { children, title } = this.props;

		if (!error) return children;

		return (
			<div className='p-4'>
				<div className='alert alert-danger' role='alert'>
					<h4 className='alert-heading'>{title}</h4>
					<p className='mb-2'>
						Halaman ini gagal ditampilkan. Data yang dimuat kemungkinan tidak sesuai
						format yang diharapkan.
					</p>
					<pre
						className='mb-3 p-2 bg-light text-dark rounded'
						style={{ whiteSpace: 'pre-wrap', fontSize: '0.85em' }}>
						{error?.message || String(error)}
					</pre>
					<button type='button' className='btn btn-danger' onClick={this.handleReset}>
						Coba lagi
					</button>
				</div>
			</div>
		);
	}
}

ErrorBoundary.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string,
};
ErrorBoundary.defaultProps = {
	children: null,
	title: 'Terjadi kesalahan',
};

export default ErrorBoundary;
